var map = {
	"./backgrounds.svg": 9676,
	"./photos.svg": 6318,
	"./templates.svg": 3562,
	"./text.svg": 4828,
	"assets/leftMenuIcons/backgrounds.svg": 9676,
	"assets/leftMenuIcons/photos.svg": 6318,
	"assets/leftMenuIcons/templates.svg": 3562,
	"assets/leftMenuIcons/text.svg": 4828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7600;